import {
  hasAccessForBranch,
  hasAccessForBranchDepartment,
  hasAccessForCompany,
  hasAccessForCompanyDepartment,
  hasAccessForLogonBranch,
  hasAccessForLogonBranchDepartment,
  hasAccessForLogonCompany,
  hasAccessForLogonCompanyDepartment,
} from "CW1/ApplicationCheckpointSecurityConditionFunctions";
import type { DependencyAccessValue, DependencyVisitorContext } from "DependencyVisitorContext";
import type { Entity } from "breeze-client";
import { isNew } from "./IsNewSecurityConditionFunction.ts";

interface SecurityConditionFunction<Mode = unknown> {
  (args: unknown[], entity: Entity, context: DependencyVisitorContext<Mode>): DependencyAccessValue<Mode, unknown>;
}

const functions: ReadonlyMap<string, SecurityConditionFunction> = new Map<string, SecurityConditionFunction>([
  ["HasAccessForBranch", hasAccessForBranch],
  ["HasAccessForBranchDepartment", hasAccessForBranchDepartment],
  ["HasAccessForCompany", hasAccessForCompany],
  ["HasAccessForCompanyDepartment", hasAccessForCompanyDepartment],
  ["HasAccessForLogonBranch", hasAccessForLogonBranch],
  ["HasAccessForLogonBranchDepartment", hasAccessForLogonBranchDepartment],
  ["HasAccessForLogonCompany", hasAccessForLogonCompany],
  ["HasAccessForLogonCompanyDepartment", hasAccessForLogonCompanyDepartment],
  ["IsNew", isNew],
]);

export function getSecurityConditionFunction(name: string): SecurityConditionFunction | undefined {
  return functions.get(name);
}
